module.exports = __webpack_public_path__ + "img/packages.5ce479c7.png";